import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import nbTranslations from './locales/nb/translations.json';
import enTranslations from './locales/en/translations.json';
import nbCategories from './locales/nb/categories.json';
import enCategories from './locales/en/categories.json';
import nbRegulatory from './locales/nb/regulatory.json';
import enRegulatory from './locales/en/regulatory.json';
import nbComponentTypes from './locales/nb/component-types.json';
import enComponentTypes from './locales/en/component-types.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
        categories: enCategories,
        regulatory: enRegulatory,
        componentTypes: enComponentTypes,
      },
      nb: {
        translation: nbTranslations,
        categories: nbCategories,
        regulatory: nbRegulatory,
        componentTypes: nbComponentTypes,
      },
    },
    fallbackLng: 'nb',
    supportedLngs: ['nb', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
